<template>
  <div
    v-if="!isEmpty"
    :class="_.recommend"
    :style="{
      marginTop: `${topRem}rem`,
      visibility: visible ? 'visible' : 'hidden',
    }"
  >
    <div :class="_.hd">
      <x-icon :src="require('./images/猜你喜欢.png')" :class="_.icon" />
      <div :class="_.title">人气精选</div>
    </div>
    <x-goods-waterfall
      :class="_.list"
      :load="loadData"
      :track="{
        from: '猜你喜欢',
      }"
      :disabled="true"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { apiPageConfigGetStateContentByApp } from '@/api'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      resourcePositionId: {
        type: String,
        default: '8aaa8b7b79f3a40d017a0f0700820108',
      },
      top: {
        type: Number,
        default: 20,
      },
    },

    data: () => ({
      visible: false,
      isEmpty: false,
    }),

    computed: {
      topRem() {
        return pxToRem(this.top)
      },
    },

    methods: {
      async loadData({ pageNumber }) {
        const res = await apiPageConfigGetStateContentByApp({
          stateId: this.resourcePositionId,
          pageIndex: pageNumber,
          pageSize: 10,
        })
        if (pageNumber === 1 && !res.list?.length) {
          this.isEmpty = true
        } else {
          this.visible = true
        }
        return res
      },
    },
  })
</script>

<style lang="scss" module>
  .recommend {
    .hd {
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
      }

      .title {
        margin-left: 4px;
        font-size: 16px;
        font-weight: bold;
        color: #222222;
      }
    }

    .list {
      margin-top: 13px;
      padding: 0 12px;
    }
  }
</style>
